/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InstructorRouteImport } from './routes/_instructor'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as InstructorCourseFeedbackRouteImport } from './routes/_instructor.course-feedback'
import { Route as InstructorCourseFeedbackDetailsRouteImport } from './routes/_instructor.course-feedback-details'
import { Route as InstructorMyCoursesRouteImport } from './routes/_instructor.my-courses'
import { Route as InstructorMyTimeRouteImport } from './routes/_instructor.my-time'
import { Route as InstructorOnDemandTutoringRouteImport } from './routes/_instructor.on-demand-tutoring'
import { Route as InstructorProfileRouteImport } from './routes/_instructor.profile'
import { Route as InstructorSendEmailsRouteImport } from './routes/_instructor.send-emails'
import { Route as InstructorSendSmsRouteImport } from './routes/_instructor.send-sms'
import { Route as InstructorSupportRouteImport } from './routes/_instructor.support'
import { Route as PublicLoginRouteImport } from './routes/_public.login'
import { Route as InstructorMyCoursesIndexRouteImport } from './routes/_instructor.my-courses.index'
import { Route as InstructorMyCoursesFutureRouteImport } from './routes/_instructor.my-courses.future'
import { Route as InstructorMyCoursesPastRouteImport } from './routes/_instructor.my-courses.past'
import { Route as InstructorOnDemandTutoringIndexRouteImport } from './routes/_instructor.on-demand-tutoring.index'
import { Route as InstructorOnDemandTutoringEditAnswerRouteImport } from './routes/_instructor.on-demand-tutoring.edit-answer'
import { Route as InstructorOnDemandTutoringQuestionDetailsRouteImport } from './routes/_instructor.on-demand-tutoring.question-details'
import { Route as InstructorRosterIdRouteImport } from './routes/_instructor.roster.$id'
import { Route as InstructorScormReportsIdRouteImport } from './routes/_instructor.scorm-reports.$id'
import { Route as InstructorStudentIdRouteImport } from './routes/_instructor.student.$id'
import { Route as InstructorStudentCoursesRouteImport } from './routes/_instructor.student.courses'
import { Route as InstructorStudentEmailRouteImport } from './routes/_instructor.student.email'
import { Route as InstructorStudentNotesRouteImport } from './routes/_instructor.student.notes'
import { Route as InstructorStudentOnDemandTutoringRouteImport } from './routes/_instructor.student.on-demand-tutoring'
import { Route as InstructorStudentSmsRouteImport } from './routes/_instructor.student.sms'
import { Route as InstructorSupportIndexRouteImport } from './routes/_instructor.support.index'
import { Route as InstructorSupportHistoryRouteImport } from './routes/_instructor.support.history'
import { Route as InstructorInstructorOnDemandTutoringBookingsRouteImport } from './routes/_instructor.instructor.on-demand-tutoring.bookings'
import { Route as InstructorStudentNotesIndexRouteImport } from './routes/_instructor.student.notes.index'
import { Route as InstructorStudentNotesEditRouteImport } from './routes/_instructor.student.notes.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorRoute = InstructorRouteImport.update({
  id: '/_instructor',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorCourseFeedbackRoute =
  InstructorCourseFeedbackRouteImport.update({
    id: '/course-feedback',
    path: '/course-feedback',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseFeedbackDetailsRoute =
  InstructorCourseFeedbackDetailsRouteImport.update({
    id: '/course-feedback-details',
    path: '/course-feedback-details',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorMyCoursesRoute = InstructorMyCoursesRouteImport.update({
  id: '/my-courses',
  path: '/my-courses',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorMyTimeRoute = InstructorMyTimeRouteImport.update({
  id: '/my-time',
  path: '/my-time',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorOnDemandTutoringRoute =
  InstructorOnDemandTutoringRouteImport.update({
    id: '/on-demand-tutoring',
    path: '/on-demand-tutoring',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorProfileRoute = InstructorProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorSendEmailsRoute = InstructorSendEmailsRouteImport.update({
  id: '/send-emails',
  path: '/send-emails',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorSendSmsRoute = InstructorSendSmsRouteImport.update({
  id: '/send-sms',
  path: '/send-sms',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorSupportRoute = InstructorSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => InstructorRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const InstructorMyCoursesIndexRoute =
  InstructorMyCoursesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InstructorMyCoursesRoute,
  } as any)
const InstructorMyCoursesFutureRoute =
  InstructorMyCoursesFutureRouteImport.update({
    id: '/future',
    path: '/future',
    getParentRoute: () => InstructorMyCoursesRoute,
  } as any)
const InstructorMyCoursesPastRoute = InstructorMyCoursesPastRouteImport.update({
  id: '/past',
  path: '/past',
  getParentRoute: () => InstructorMyCoursesRoute,
} as any)
const InstructorOnDemandTutoringIndexRoute =
  InstructorOnDemandTutoringIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InstructorOnDemandTutoringRoute,
  } as any)
const InstructorOnDemandTutoringEditAnswerRoute =
  InstructorOnDemandTutoringEditAnswerRouteImport.update({
    id: '/edit-answer',
    path: '/edit-answer',
    getParentRoute: () => InstructorOnDemandTutoringRoute,
  } as any)
const InstructorOnDemandTutoringQuestionDetailsRoute =
  InstructorOnDemandTutoringQuestionDetailsRouteImport.update({
    id: '/question-details',
    path: '/question-details',
    getParentRoute: () => InstructorOnDemandTutoringRoute,
  } as any)
const InstructorRosterIdRoute = InstructorRosterIdRouteImport.update({
  id: '/roster/$id',
  path: '/roster/$id',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorScormReportsIdRoute =
  InstructorScormReportsIdRouteImport.update({
    id: '/scorm-reports/$id',
    path: '/scorm-reports/$id',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorStudentIdRoute = InstructorStudentIdRouteImport.update({
  id: '/student/$id',
  path: '/student/$id',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorStudentCoursesRoute =
  InstructorStudentCoursesRouteImport.update({
    id: '/student/courses',
    path: '/student/courses',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorStudentEmailRoute = InstructorStudentEmailRouteImport.update({
  id: '/student/email',
  path: '/student/email',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorStudentNotesRoute = InstructorStudentNotesRouteImport.update({
  id: '/student/notes',
  path: '/student/notes',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorStudentOnDemandTutoringRoute =
  InstructorStudentOnDemandTutoringRouteImport.update({
    id: '/student/on-demand-tutoring',
    path: '/student/on-demand-tutoring',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorStudentSmsRoute = InstructorStudentSmsRouteImport.update({
  id: '/student/sms',
  path: '/student/sms',
  getParentRoute: () => InstructorRoute,
} as any)
const InstructorSupportIndexRoute = InstructorSupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InstructorSupportRoute,
} as any)
const InstructorSupportHistoryRoute =
  InstructorSupportHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => InstructorSupportRoute,
  } as any)
const InstructorInstructorOnDemandTutoringBookingsRoute =
  InstructorInstructorOnDemandTutoringBookingsRouteImport.update({
    id: '/instructor/on-demand-tutoring/bookings',
    path: '/instructor/on-demand-tutoring/bookings',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorStudentNotesIndexRoute =
  InstructorStudentNotesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InstructorStudentNotesRoute,
  } as any)
const InstructorStudentNotesEditRoute =
  InstructorStudentNotesEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => InstructorStudentNotesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/course-feedback': typeof InstructorCourseFeedbackRoute
  '/course-feedback-details': typeof InstructorCourseFeedbackDetailsRoute
  '/my-courses': typeof InstructorMyCoursesRouteWithChildren
  '/my-time': typeof InstructorMyTimeRoute
  '/on-demand-tutoring': typeof InstructorOnDemandTutoringRouteWithChildren
  '/profile': typeof InstructorProfileRoute
  '/send-emails': typeof InstructorSendEmailsRoute
  '/send-sms': typeof InstructorSendSmsRoute
  '/support': typeof InstructorSupportRouteWithChildren
  '/login': typeof PublicLoginRoute
  '/my-courses/future': typeof InstructorMyCoursesFutureRoute
  '/my-courses/past': typeof InstructorMyCoursesPastRoute
  '/on-demand-tutoring/edit-answer': typeof InstructorOnDemandTutoringEditAnswerRoute
  '/on-demand-tutoring/question-details': typeof InstructorOnDemandTutoringQuestionDetailsRoute
  '/roster/$id': typeof InstructorRosterIdRoute
  '/scorm-reports/$id': typeof InstructorScormReportsIdRoute
  '/student/$id': typeof InstructorStudentIdRoute
  '/student/courses': typeof InstructorStudentCoursesRoute
  '/student/email': typeof InstructorStudentEmailRoute
  '/student/notes': typeof InstructorStudentNotesRouteWithChildren
  '/student/on-demand-tutoring': typeof InstructorStudentOnDemandTutoringRoute
  '/student/sms': typeof InstructorStudentSmsRoute
  '/support/history': typeof InstructorSupportHistoryRoute
  '/my-courses/': typeof InstructorMyCoursesIndexRoute
  '/on-demand-tutoring/': typeof InstructorOnDemandTutoringIndexRoute
  '/support/': typeof InstructorSupportIndexRoute
  '/instructor/on-demand-tutoring/bookings': typeof InstructorInstructorOnDemandTutoringBookingsRoute
  '/student/notes/edit': typeof InstructorStudentNotesEditRoute
  '/student/notes/': typeof InstructorStudentNotesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/course-feedback': typeof InstructorCourseFeedbackRoute
  '/course-feedback-details': typeof InstructorCourseFeedbackDetailsRoute
  '/my-time': typeof InstructorMyTimeRoute
  '/profile': typeof InstructorProfileRoute
  '/send-emails': typeof InstructorSendEmailsRoute
  '/send-sms': typeof InstructorSendSmsRoute
  '/login': typeof PublicLoginRoute
  '/my-courses/future': typeof InstructorMyCoursesFutureRoute
  '/my-courses/past': typeof InstructorMyCoursesPastRoute
  '/on-demand-tutoring/edit-answer': typeof InstructorOnDemandTutoringEditAnswerRoute
  '/on-demand-tutoring/question-details': typeof InstructorOnDemandTutoringQuestionDetailsRoute
  '/roster/$id': typeof InstructorRosterIdRoute
  '/scorm-reports/$id': typeof InstructorScormReportsIdRoute
  '/student/$id': typeof InstructorStudentIdRoute
  '/student/courses': typeof InstructorStudentCoursesRoute
  '/student/email': typeof InstructorStudentEmailRoute
  '/student/on-demand-tutoring': typeof InstructorStudentOnDemandTutoringRoute
  '/student/sms': typeof InstructorStudentSmsRoute
  '/support/history': typeof InstructorSupportHistoryRoute
  '/my-courses': typeof InstructorMyCoursesIndexRoute
  '/on-demand-tutoring': typeof InstructorOnDemandTutoringIndexRoute
  '/support': typeof InstructorSupportIndexRoute
  '/instructor/on-demand-tutoring/bookings': typeof InstructorInstructorOnDemandTutoringBookingsRoute
  '/student/notes/edit': typeof InstructorStudentNotesEditRoute
  '/student/notes': typeof InstructorStudentNotesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_instructor': typeof InstructorRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_instructor/course-feedback': typeof InstructorCourseFeedbackRoute
  '/_instructor/course-feedback-details': typeof InstructorCourseFeedbackDetailsRoute
  '/_instructor/my-courses': typeof InstructorMyCoursesRouteWithChildren
  '/_instructor/my-time': typeof InstructorMyTimeRoute
  '/_instructor/on-demand-tutoring': typeof InstructorOnDemandTutoringRouteWithChildren
  '/_instructor/profile': typeof InstructorProfileRoute
  '/_instructor/send-emails': typeof InstructorSendEmailsRoute
  '/_instructor/send-sms': typeof InstructorSendSmsRoute
  '/_instructor/support': typeof InstructorSupportRouteWithChildren
  '/_public/login': typeof PublicLoginRoute
  '/_instructor/my-courses/future': typeof InstructorMyCoursesFutureRoute
  '/_instructor/my-courses/past': typeof InstructorMyCoursesPastRoute
  '/_instructor/on-demand-tutoring/edit-answer': typeof InstructorOnDemandTutoringEditAnswerRoute
  '/_instructor/on-demand-tutoring/question-details': typeof InstructorOnDemandTutoringQuestionDetailsRoute
  '/_instructor/roster/$id': typeof InstructorRosterIdRoute
  '/_instructor/scorm-reports/$id': typeof InstructorScormReportsIdRoute
  '/_instructor/student/$id': typeof InstructorStudentIdRoute
  '/_instructor/student/courses': typeof InstructorStudentCoursesRoute
  '/_instructor/student/email': typeof InstructorStudentEmailRoute
  '/_instructor/student/notes': typeof InstructorStudentNotesRouteWithChildren
  '/_instructor/student/on-demand-tutoring': typeof InstructorStudentOnDemandTutoringRoute
  '/_instructor/student/sms': typeof InstructorStudentSmsRoute
  '/_instructor/support/history': typeof InstructorSupportHistoryRoute
  '/_instructor/my-courses/': typeof InstructorMyCoursesIndexRoute
  '/_instructor/on-demand-tutoring/': typeof InstructorOnDemandTutoringIndexRoute
  '/_instructor/support/': typeof InstructorSupportIndexRoute
  '/_instructor/instructor/on-demand-tutoring/bookings': typeof InstructorInstructorOnDemandTutoringBookingsRoute
  '/_instructor/student/notes/edit': typeof InstructorStudentNotesEditRoute
  '/_instructor/student/notes/': typeof InstructorStudentNotesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/course-feedback'
    | '/course-feedback-details'
    | '/my-courses'
    | '/my-time'
    | '/on-demand-tutoring'
    | '/profile'
    | '/send-emails'
    | '/send-sms'
    | '/support'
    | '/login'
    | '/my-courses/future'
    | '/my-courses/past'
    | '/on-demand-tutoring/edit-answer'
    | '/on-demand-tutoring/question-details'
    | '/roster/$id'
    | '/scorm-reports/$id'
    | '/student/$id'
    | '/student/courses'
    | '/student/email'
    | '/student/notes'
    | '/student/on-demand-tutoring'
    | '/student/sms'
    | '/support/history'
    | '/my-courses/'
    | '/on-demand-tutoring/'
    | '/support/'
    | '/instructor/on-demand-tutoring/bookings'
    | '/student/notes/edit'
    | '/student/notes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/course-feedback'
    | '/course-feedback-details'
    | '/my-time'
    | '/profile'
    | '/send-emails'
    | '/send-sms'
    | '/login'
    | '/my-courses/future'
    | '/my-courses/past'
    | '/on-demand-tutoring/edit-answer'
    | '/on-demand-tutoring/question-details'
    | '/roster/$id'
    | '/scorm-reports/$id'
    | '/student/$id'
    | '/student/courses'
    | '/student/email'
    | '/student/on-demand-tutoring'
    | '/student/sms'
    | '/support/history'
    | '/my-courses'
    | '/on-demand-tutoring'
    | '/support'
    | '/instructor/on-demand-tutoring/bookings'
    | '/student/notes/edit'
    | '/student/notes'
  id:
    | '__root__'
    | '/'
    | '/_instructor'
    | '/_public'
    | '/_instructor/course-feedback'
    | '/_instructor/course-feedback-details'
    | '/_instructor/my-courses'
    | '/_instructor/my-time'
    | '/_instructor/on-demand-tutoring'
    | '/_instructor/profile'
    | '/_instructor/send-emails'
    | '/_instructor/send-sms'
    | '/_instructor/support'
    | '/_public/login'
    | '/_instructor/my-courses/future'
    | '/_instructor/my-courses/past'
    | '/_instructor/on-demand-tutoring/edit-answer'
    | '/_instructor/on-demand-tutoring/question-details'
    | '/_instructor/roster/$id'
    | '/_instructor/scorm-reports/$id'
    | '/_instructor/student/$id'
    | '/_instructor/student/courses'
    | '/_instructor/student/email'
    | '/_instructor/student/notes'
    | '/_instructor/student/on-demand-tutoring'
    | '/_instructor/student/sms'
    | '/_instructor/support/history'
    | '/_instructor/my-courses/'
    | '/_instructor/on-demand-tutoring/'
    | '/_instructor/support/'
    | '/_instructor/instructor/on-demand-tutoring/bookings'
    | '/_instructor/student/notes/edit'
    | '/_instructor/student/notes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InstructorRoute: typeof InstructorRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_instructor': {
      id: '/_instructor'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof InstructorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_instructor/course-feedback': {
      id: '/_instructor/course-feedback'
      path: '/course-feedback'
      fullPath: '/course-feedback'
      preLoaderRoute: typeof InstructorCourseFeedbackRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/course-feedback-details': {
      id: '/_instructor/course-feedback-details'
      path: '/course-feedback-details'
      fullPath: '/course-feedback-details'
      preLoaderRoute: typeof InstructorCourseFeedbackDetailsRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/my-courses': {
      id: '/_instructor/my-courses'
      path: '/my-courses'
      fullPath: '/my-courses'
      preLoaderRoute: typeof InstructorMyCoursesRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/my-time': {
      id: '/_instructor/my-time'
      path: '/my-time'
      fullPath: '/my-time'
      preLoaderRoute: typeof InstructorMyTimeRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/on-demand-tutoring': {
      id: '/_instructor/on-demand-tutoring'
      path: '/on-demand-tutoring'
      fullPath: '/on-demand-tutoring'
      preLoaderRoute: typeof InstructorOnDemandTutoringRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/profile': {
      id: '/_instructor/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof InstructorProfileRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/send-emails': {
      id: '/_instructor/send-emails'
      path: '/send-emails'
      fullPath: '/send-emails'
      preLoaderRoute: typeof InstructorSendEmailsRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/send-sms': {
      id: '/_instructor/send-sms'
      path: '/send-sms'
      fullPath: '/send-sms'
      preLoaderRoute: typeof InstructorSendSmsRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/support': {
      id: '/_instructor/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof InstructorSupportRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_instructor/my-courses/': {
      id: '/_instructor/my-courses/'
      path: '/'
      fullPath: '/my-courses/'
      preLoaderRoute: typeof InstructorMyCoursesIndexRouteImport
      parentRoute: typeof InstructorMyCoursesRoute
    }
    '/_instructor/my-courses/future': {
      id: '/_instructor/my-courses/future'
      path: '/future'
      fullPath: '/my-courses/future'
      preLoaderRoute: typeof InstructorMyCoursesFutureRouteImport
      parentRoute: typeof InstructorMyCoursesRoute
    }
    '/_instructor/my-courses/past': {
      id: '/_instructor/my-courses/past'
      path: '/past'
      fullPath: '/my-courses/past'
      preLoaderRoute: typeof InstructorMyCoursesPastRouteImport
      parentRoute: typeof InstructorMyCoursesRoute
    }
    '/_instructor/on-demand-tutoring/': {
      id: '/_instructor/on-demand-tutoring/'
      path: '/'
      fullPath: '/on-demand-tutoring/'
      preLoaderRoute: typeof InstructorOnDemandTutoringIndexRouteImport
      parentRoute: typeof InstructorOnDemandTutoringRoute
    }
    '/_instructor/on-demand-tutoring/edit-answer': {
      id: '/_instructor/on-demand-tutoring/edit-answer'
      path: '/edit-answer'
      fullPath: '/on-demand-tutoring/edit-answer'
      preLoaderRoute: typeof InstructorOnDemandTutoringEditAnswerRouteImport
      parentRoute: typeof InstructorOnDemandTutoringRoute
    }
    '/_instructor/on-demand-tutoring/question-details': {
      id: '/_instructor/on-demand-tutoring/question-details'
      path: '/question-details'
      fullPath: '/on-demand-tutoring/question-details'
      preLoaderRoute: typeof InstructorOnDemandTutoringQuestionDetailsRouteImport
      parentRoute: typeof InstructorOnDemandTutoringRoute
    }
    '/_instructor/roster/$id': {
      id: '/_instructor/roster/$id'
      path: '/roster/$id'
      fullPath: '/roster/$id'
      preLoaderRoute: typeof InstructorRosterIdRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/scorm-reports/$id': {
      id: '/_instructor/scorm-reports/$id'
      path: '/scorm-reports/$id'
      fullPath: '/scorm-reports/$id'
      preLoaderRoute: typeof InstructorScormReportsIdRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/student/$id': {
      id: '/_instructor/student/$id'
      path: '/student/$id'
      fullPath: '/student/$id'
      preLoaderRoute: typeof InstructorStudentIdRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/student/courses': {
      id: '/_instructor/student/courses'
      path: '/student/courses'
      fullPath: '/student/courses'
      preLoaderRoute: typeof InstructorStudentCoursesRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/student/email': {
      id: '/_instructor/student/email'
      path: '/student/email'
      fullPath: '/student/email'
      preLoaderRoute: typeof InstructorStudentEmailRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/student/notes': {
      id: '/_instructor/student/notes'
      path: '/student/notes'
      fullPath: '/student/notes'
      preLoaderRoute: typeof InstructorStudentNotesRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/student/on-demand-tutoring': {
      id: '/_instructor/student/on-demand-tutoring'
      path: '/student/on-demand-tutoring'
      fullPath: '/student/on-demand-tutoring'
      preLoaderRoute: typeof InstructorStudentOnDemandTutoringRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/student/sms': {
      id: '/_instructor/student/sms'
      path: '/student/sms'
      fullPath: '/student/sms'
      preLoaderRoute: typeof InstructorStudentSmsRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/support/': {
      id: '/_instructor/support/'
      path: '/'
      fullPath: '/support/'
      preLoaderRoute: typeof InstructorSupportIndexRouteImport
      parentRoute: typeof InstructorSupportRoute
    }
    '/_instructor/support/history': {
      id: '/_instructor/support/history'
      path: '/history'
      fullPath: '/support/history'
      preLoaderRoute: typeof InstructorSupportHistoryRouteImport
      parentRoute: typeof InstructorSupportRoute
    }
    '/_instructor/instructor/on-demand-tutoring/bookings': {
      id: '/_instructor/instructor/on-demand-tutoring/bookings'
      path: '/instructor/on-demand-tutoring/bookings'
      fullPath: '/instructor/on-demand-tutoring/bookings'
      preLoaderRoute: typeof InstructorInstructorOnDemandTutoringBookingsRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/_instructor/student/notes/': {
      id: '/_instructor/student/notes/'
      path: '/'
      fullPath: '/student/notes/'
      preLoaderRoute: typeof InstructorStudentNotesIndexRouteImport
      parentRoute: typeof InstructorStudentNotesRoute
    }
    '/_instructor/student/notes/edit': {
      id: '/_instructor/student/notes/edit'
      path: '/edit'
      fullPath: '/student/notes/edit'
      preLoaderRoute: typeof InstructorStudentNotesEditRouteImport
      parentRoute: typeof InstructorStudentNotesRoute
    }
  }
}

interface InstructorMyCoursesRouteChildren {
  InstructorMyCoursesFutureRoute: typeof InstructorMyCoursesFutureRoute
  InstructorMyCoursesPastRoute: typeof InstructorMyCoursesPastRoute
  InstructorMyCoursesIndexRoute: typeof InstructorMyCoursesIndexRoute
}

const InstructorMyCoursesRouteChildren: InstructorMyCoursesRouteChildren = {
  InstructorMyCoursesFutureRoute: InstructorMyCoursesFutureRoute,
  InstructorMyCoursesPastRoute: InstructorMyCoursesPastRoute,
  InstructorMyCoursesIndexRoute: InstructorMyCoursesIndexRoute,
}

const InstructorMyCoursesRouteWithChildren =
  InstructorMyCoursesRoute._addFileChildren(InstructorMyCoursesRouteChildren)

interface InstructorOnDemandTutoringRouteChildren {
  InstructorOnDemandTutoringEditAnswerRoute: typeof InstructorOnDemandTutoringEditAnswerRoute
  InstructorOnDemandTutoringQuestionDetailsRoute: typeof InstructorOnDemandTutoringQuestionDetailsRoute
  InstructorOnDemandTutoringIndexRoute: typeof InstructorOnDemandTutoringIndexRoute
}

const InstructorOnDemandTutoringRouteChildren: InstructorOnDemandTutoringRouteChildren =
  {
    InstructorOnDemandTutoringEditAnswerRoute:
      InstructorOnDemandTutoringEditAnswerRoute,
    InstructorOnDemandTutoringQuestionDetailsRoute:
      InstructorOnDemandTutoringQuestionDetailsRoute,
    InstructorOnDemandTutoringIndexRoute: InstructorOnDemandTutoringIndexRoute,
  }

const InstructorOnDemandTutoringRouteWithChildren =
  InstructorOnDemandTutoringRoute._addFileChildren(
    InstructorOnDemandTutoringRouteChildren,
  )

interface InstructorSupportRouteChildren {
  InstructorSupportHistoryRoute: typeof InstructorSupportHistoryRoute
  InstructorSupportIndexRoute: typeof InstructorSupportIndexRoute
}

const InstructorSupportRouteChildren: InstructorSupportRouteChildren = {
  InstructorSupportHistoryRoute: InstructorSupportHistoryRoute,
  InstructorSupportIndexRoute: InstructorSupportIndexRoute,
}

const InstructorSupportRouteWithChildren =
  InstructorSupportRoute._addFileChildren(InstructorSupportRouteChildren)

interface InstructorStudentNotesRouteChildren {
  InstructorStudentNotesEditRoute: typeof InstructorStudentNotesEditRoute
  InstructorStudentNotesIndexRoute: typeof InstructorStudentNotesIndexRoute
}

const InstructorStudentNotesRouteChildren: InstructorStudentNotesRouteChildren =
  {
    InstructorStudentNotesEditRoute: InstructorStudentNotesEditRoute,
    InstructorStudentNotesIndexRoute: InstructorStudentNotesIndexRoute,
  }

const InstructorStudentNotesRouteWithChildren =
  InstructorStudentNotesRoute._addFileChildren(
    InstructorStudentNotesRouteChildren,
  )

interface InstructorRouteChildren {
  InstructorCourseFeedbackRoute: typeof InstructorCourseFeedbackRoute
  InstructorCourseFeedbackDetailsRoute: typeof InstructorCourseFeedbackDetailsRoute
  InstructorMyCoursesRoute: typeof InstructorMyCoursesRouteWithChildren
  InstructorMyTimeRoute: typeof InstructorMyTimeRoute
  InstructorOnDemandTutoringRoute: typeof InstructorOnDemandTutoringRouteWithChildren
  InstructorProfileRoute: typeof InstructorProfileRoute
  InstructorSendEmailsRoute: typeof InstructorSendEmailsRoute
  InstructorSendSmsRoute: typeof InstructorSendSmsRoute
  InstructorSupportRoute: typeof InstructorSupportRouteWithChildren
  InstructorRosterIdRoute: typeof InstructorRosterIdRoute
  InstructorScormReportsIdRoute: typeof InstructorScormReportsIdRoute
  InstructorStudentIdRoute: typeof InstructorStudentIdRoute
  InstructorStudentCoursesRoute: typeof InstructorStudentCoursesRoute
  InstructorStudentEmailRoute: typeof InstructorStudentEmailRoute
  InstructorStudentNotesRoute: typeof InstructorStudentNotesRouteWithChildren
  InstructorStudentOnDemandTutoringRoute: typeof InstructorStudentOnDemandTutoringRoute
  InstructorStudentSmsRoute: typeof InstructorStudentSmsRoute
  InstructorInstructorOnDemandTutoringBookingsRoute: typeof InstructorInstructorOnDemandTutoringBookingsRoute
}

const InstructorRouteChildren: InstructorRouteChildren = {
  InstructorCourseFeedbackRoute: InstructorCourseFeedbackRoute,
  InstructorCourseFeedbackDetailsRoute: InstructorCourseFeedbackDetailsRoute,
  InstructorMyCoursesRoute: InstructorMyCoursesRouteWithChildren,
  InstructorMyTimeRoute: InstructorMyTimeRoute,
  InstructorOnDemandTutoringRoute: InstructorOnDemandTutoringRouteWithChildren,
  InstructorProfileRoute: InstructorProfileRoute,
  InstructorSendEmailsRoute: InstructorSendEmailsRoute,
  InstructorSendSmsRoute: InstructorSendSmsRoute,
  InstructorSupportRoute: InstructorSupportRouteWithChildren,
  InstructorRosterIdRoute: InstructorRosterIdRoute,
  InstructorScormReportsIdRoute: InstructorScormReportsIdRoute,
  InstructorStudentIdRoute: InstructorStudentIdRoute,
  InstructorStudentCoursesRoute: InstructorStudentCoursesRoute,
  InstructorStudentEmailRoute: InstructorStudentEmailRoute,
  InstructorStudentNotesRoute: InstructorStudentNotesRouteWithChildren,
  InstructorStudentOnDemandTutoringRoute:
    InstructorStudentOnDemandTutoringRoute,
  InstructorStudentSmsRoute: InstructorStudentSmsRoute,
  InstructorInstructorOnDemandTutoringBookingsRoute:
    InstructorInstructorOnDemandTutoringBookingsRoute,
}

const InstructorRouteWithChildren = InstructorRoute._addFileChildren(
  InstructorRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InstructorRoute: InstructorRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
